import React from 'react'
import { useResponsive, useTranslations } from '@dustin-web/microsite-components/src/hooks'
import DustinLogo from '@dustin-web/microsite-components/src/dustin-logo'

const logoWidthBusiness = 122

const HeaderLogo = () => {
  const { isSmallScreen } = useResponsive()
  const { translate } = useTranslations()

  const logoWidth = logoWidthBusiness

  const desktopLogoStyles = {
    width: logoWidth,
  }

  const mobileLogoStyles = {
    width: '100%',
    maxWidth: logoWidth,
  }

  return (
    <a
      data-ga-title="home"
      className="c-header__logo"
      href="/"
      aria-label={translate('SiteSelector_Title_Business')}>
      <DustinLogo style={isSmallScreen ? mobileLogoStyles : desktopLogoStyles} className="u-mr-8" />
    </a>
  )
}

export default HeaderLogo
